import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material'
import { ExplanationAccordion } from 'components'
import { PersonDeclarantInformationDto, personDeclarantInformationValidationSchema } from 'dtos'
import { Formik } from 'formik'

interface DeclarantAddEditDialogProps {
  initialValues: PersonDeclarantInformationDto
  loading: boolean
  onClose: () => void
  onSave: (values: PersonDeclarantInformationDto) => void
  open: boolean
}

export default function DeclarantAddEditDialog({ initialValues, loading, onClose, onSave, open }: DeclarantAddEditDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
        validateOnBlur={false}
        validateOnChange={true}
        validationSchema={personDeclarantInformationValidationSchema}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Edit Declarant Information</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.declarantCapacity && errors.declarantCapacity)}
                      helperText={touched.declarantCapacity && errors.declarantCapacity}
                      label='Declarant Capacity'
                      name='declarantCapacity'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.declarantCapacity}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <input
                      accept='.png,.jpg,.jpeg'
                      hidden
                      type='file'
                      id='declarantSignatureFileInput'
                      onChange={e => {
                        if (e.target.files && e.target.files.length > 0) {
                          setFieldValue('declarantSignatureFile', e.target.files[0])
                        }
                      }}
                    />

                    <Button
                      disabled={loading || isSubmitting}
                      onClick={() => {
                        document.getElementById('declarantSignatureFileInput')?.click()
                      }}
                      variant='contained'
                    >
                      UPLOAD SIGNATURE
                    </Button>

                    <Typography color='#808080' display='inline' variant='body2' sx={{ ml: 1 }}>
                      {values.declarantSignatureFile?.name ?? values.declarantSignatureFileName ?? 'No file uploaded'}
                    </Typography>

                    {errors.declarantSignatureFile && (
                      <Typography color='error' variant='body2'>
                        {errors.declarantSignatureFile}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <ExplanationAccordion variant='outlined'>
                      ||All fields are required.|| Signature must be uploaded to save.|| Image formats accepted: .PNG, .JPG or
                      .JPEG|| Maximum files size for upload up 20Mbs ||
                    </ExplanationAccordion>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={loading || isSubmitting} color='inherit' onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={loading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
